// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"19fe06c3","703":"4251dbb8"}[chunkId] + ".chunk.js";
};